/**
* Service Tabs JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service Tabs component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'service-tabs',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.service-tabs' ).length ) {
        $( '.service-tabs__slider' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'slide',
            rewind: true,
            gap: '2rem',
            perPage: 3,
            pagination: false,
            speed: 800,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          } );

          const progressBar = slider.root.querySelector( '.service-tabs__progress-bar' );
          const progressAmount = slider.root.querySelector( '.service-tabs__progress-amount' );

          slider.on( 'mounted move', function( newIndex, prevIndex, destIndex ) {
            const end = slider.Components.Controller.getEnd() + 1;
            const slideCount = slider.Components.Slides.getLength();
            const rate = Math.min( ( slider.index + 1 ) / end, 1 );
            progressBar.style.width = String( 100 * rate ) + '%';

            /* updates sr-only text of progress bar */
            if ( slideCount >= 3 ) {
              $( progressAmount ).text( `${slider.index + 3} of ${slideCount} cards` );
            } else {
              $( progressAmount ).text( `${slideCount} of ${slideCount} cards` );
            }
          } );

          slider.on( 'overflow', function( isOverflow ) {
            slider.options = {
              drag: isOverflow,
            };
          } );

          slider.mount( );

          const tabBtn = $( element ).data( 'tab-btn' );
          $( `#${tabBtn}` ).on( 'click', function( ) {
            slider.destroy( true );
            slider.mount();
          } );
        } );

        // make active button have tabindex of 1
        $( '.service-tabs__tab-btn' ).on( 'toggleAfter', ( event ) => {
          if ( window.easyToggleState.isActive( event.target ) ) {
            $( event.target ).attr( 'tabindex', 0 );
          } else {
            $( event.target ).attr( 'tabindex', -1 );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-tabs', COMPONENT );
} )( app );
